
export const truncateString = (name: string, maxChars: number) => {
  const truncatedName =
    name.length <= maxChars ? name : `${name.slice(0, maxChars)}...`;

  return truncatedName;
};